"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
/**
 * @internal
 */
function delay(promiseOrmilliseconds, maybeMilliseconds) {
    if (typeof promiseOrmilliseconds === 'number') {
        return new Promise((resolve) => setTimeout(resolve, promiseOrmilliseconds));
    }
    return new Promise((resolve) => setTimeout(() => resolve(promiseOrmilliseconds), maybeMilliseconds));
}
exports.delay = delay;
//# sourceMappingURL=delay.js.map